import React, { memo, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import SearchIcon from 'transfix-icons/build/SearchIcon'
import ShipmentsIcon from 'transfix-icons/build/ShipmentsIcon'
import { Button } from 'transfix-ui/components/Button'
import Card from 'transfix-ui/components/Card'
import Typography from 'transfix-ui/core/Typography'
import { makeStyles } from 'transfix-ui/core/styles'
import { brandColors } from 'transfix-ui/theme/colors'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'

const useActiveShipmentsMapEmptyStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(255, 255, 255, 0.40)',
    backdropFilter: 'blur(2px)',
    position: 'absolute',
    top: '0',
    bottom: '0',
    left: '0',
    right: '0',
    zIndex: 1,
  },
  card: {
    padding: `${theme.spacing(3)} ${theme.spacing(6)}`,
    display: 'inline-block',
    boxShadow: 'none',
    borderColor: brandColors.coolGray2,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  boxIcon: {
    background: brandColors.coolGray1,
    padding: theme.spacing(1.5),
    borderRadius: '50%',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  copy: {
    margin: `${theme.spacing(1.5)} 0 ${theme.spacing(2.5)}`,
    maxWidth: 350,
    textAlign: 'center',
  },
  buttons: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(2),
  },
}))

export interface IActiveShipmentsMapEmptyProps {}

const ActiveShipmentsMapEmpty = memo<IActiveShipmentsMapEmptyProps>(() => {
  const { trackEvent } = useFMSAnalytics()
  const history = useHistory()
  const classes = useActiveShipmentsMapEmptyStyles()

  const myLoadsClickHandler = useCallback(() => {
    history.push('/loads')
    trackEvent('Homepage', 'HOME_LOAD_SUMMARY_CLICKED_MY_LOADS_BUTTON')
  }, [history, trackEvent])

  const findLoadsClickHandler = useCallback(() => {
    history.push('/book')
    trackEvent('Homepage', 'HOME_LOAD_SUMMARY_CLICKED_FIND_LOADS_BUTTON')
  }, [history, trackEvent])

  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <div className={classes.content}>
          <div className={classes.boxIcon}>
            <ShipmentsIcon size='large' color='coolGray6' />
          </div>
          <Typography variant='body2' component='div' className={classes.copy}>
            Find and dispatch loads to track their location in real-time using the Transfix mobile
            app.
          </Typography>
          <div className={classes.buttons}>
            <Button color='secondary' fullWidth onClick={myLoadsClickHandler}>
              My Loads
            </Button>
            <Button
              color='primary'
              startIcon={<SearchIcon size='large' />}
              fullWidth
              onClick={findLoadsClickHandler}>
              Find Loads
            </Button>
          </div>
        </div>
      </Card>
    </div>
  )
})

export default ActiveShipmentsMapEmpty
